<script lang="ts" generics="TProps extends __RecordStringAny">
    import WithContainerContext from '$components/Context/WithContainerContext.svelte';
    import type { ShareableContainer } from '$lib/container/shareableContainer.js';
    import type { SvelteComponent } from 'svelte';
    import type { Constructor } from 'type-fest';
    import WithSecuredAreaModalContext from '$components/Context/WithSecuredAreaModalContext.svelte';

    export let container: ShareableContainer;

    export let component: Constructor<SvelteComponent<TProps>>;
    export let props: TProps;
</script>

<WithContainerContext {container}>
    <WithSecuredAreaModalContext>
        <svelte:component this={component} {...props} />
    </WithSecuredAreaModalContext>
</WithContainerContext>
